import { render } from "./BrDeferral.vue?vue&type=template&id=6ffe18e2&scoped=true"
import script from "./BrDeferral.vue?vue&type=script&lang=js"
export * from "./BrDeferral.vue?vue&type=script&lang=js"

import "./BrDeferral.vue?vue&type=style&index=0&id=6ffe18e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffe18e2"]])

export default __exports__